import { clearSelectedPromo } from '../store/slices/selectedPromoSlice';
import { resetBudgetState } from '../store/slices/budgetSlice';
import {
    CRYPTO_CRYSTALS_DEFAULT_PROMO_DAY,
    DEFAULT_PROMO_DAY,
    resetPromoTime,
} from '../store/slices/promoTimeSlice';
import { clearData } from '../store/slices/promoTelegramSlice';
import { setSelectedId } from '../store/slices/crystalsSlice';
import { clearTasks } from '../store/slices/TasksSlice';
import { resetForm } from '../store/slices/promoFormSlice';
import { getDefaultParticipantsCount, getDefaultWinnersCount, getCrystalCategoryPlayers } from './participantLimits';

export const PROMO_FORM_PAGE_IDS = [1, 2, 3];

const PROMO_PAGE = {
    CRYSTALS: 1,
    CRYPTO_CRYSTALS: 2,
    CRYPTO_ONLY: 3,
};

const DEFAULT_BUDGET = 1;
const DEFAULT_BLOCKCHAIN = 'ETH';
const PROMOTER_LINK_PLACEHOLDERS = new Set(['', 'Promoter link', 'Promoter TG link']);

function getExpectedPromoDay(pageId) {
    if (pageId === PROMO_PAGE.CRYPTO_CRYSTALS) return CRYPTO_CRYSTALS_DEFAULT_PROMO_DAY;
    if (pageId === PROMO_PAGE.CRYPTO_ONLY) return DEFAULT_PROMO_DAY;
    return null;
}

export function isPromoFormPage(pageId) {
    return PROMO_FORM_PAGE_IDS.includes(pageId);
}

export function hasPromoFormDraft(state) {
    if (state.selectedPromo?.isEditMode) return true;

    const form = state.promoForm;
    if (form?.bonusPosition) return true;

    const { budget, foundToken, promoterWalletAddress, selectedBlockchain } = state.budget || {};
    if (foundToken) return true;
    if (promoterWalletAddress) return true;
    if (budget != null && budget !== DEFAULT_BUDGET) return true;
    if (selectedBlockchain && selectedBlockchain !== DEFAULT_BLOCKCHAIN) return true;

    const { link, data } = state.promoTelegram || {};
    const normalizedLink = String(link || '').trim();
    if (normalizedLink && !PROMOTER_LINK_PLACEHOLDERS.has(normalizedLink)) return true;
    if (data?.name) return true;

    const pageId = state.page?.currentPageId;
    const expectedPromoDay = getExpectedPromoDay(pageId);
    const { selectedDay, customDays } = state.promoTime || {};
    if (expectedPromoDay != null) {
        if (selectedDay != null && selectedDay !== expectedPromoDay) return true;
        if (customDays?.length > 0) return true;
    }

    const tasks = state.tasks;
    if (tasks?.tasksModified || tasks?.items?.length > 0) return true;

    if (form?.title?.trim()) return true;

    const crystals = state.crystals?.items || [];
    const selectedId = state.crystals?.selectedId;
    const category = form?.selectedCrystalCategory || crystals.find((c) => c.id === selectedId);
    if (category && pageId !== PROMO_PAGE.CRYSTALS) {
        const isOnlyCrystalsCategory = category.promoType === 'onlyCrystals';
        const expectedParticipants = isOnlyCrystalsCategory
            ? getCrystalCategoryPlayers(category)
            : getDefaultParticipantsCount(category);
        const expectedWinners = isOnlyCrystalsCategory
            ? getCrystalCategoryPlayers(category)
            : getDefaultWinnersCount(category);

        if (
            form.participantsCount > 0
            && form.participantsCount !== expectedParticipants
        ) {
            return true;
        }
        if (
            form.prizePlacesCount > 0
            && form.prizePlacesCount !== expectedWinners
        ) {
            return true;
        }
    }

    return false;
}

export function clearPromoFormFields(dispatch) {
    dispatch(resetBudgetState());
    dispatch(resetPromoTime());
    dispatch(clearData());
    dispatch(setSelectedId(null));
    dispatch(clearTasks());
    dispatch(resetForm());
}

export function clearPromoCreationState(dispatch) {
    dispatch(clearSelectedPromo());
    clearPromoFormFields(dispatch);
}
